import { ExternalCalendarEvent } from '@griply/types';

import { getCalendarEventReferenceDate } from './get-calendar-event-reference-date';

// Seeding every cached window would show a next-week event under today, which renders unfiltered.
export const doesWindowCoverExternalEvent = (
  queryKey: readonly unknown[],
  event: ExternalCalendarEvent,
): boolean => {
  const [, windowStart, windowEnd] = queryKey;
  if (typeof windowStart !== 'string' || typeof windowEnd !== 'string') {
    return false;
  }

  const start = new Date(windowStart);
  const end = new Date(windowEnd);

  // A boundary carrying neither field is malformed; fall back so it reads as "outside".
  return (
    getCalendarEventReferenceDate(event.start, end) < end &&
    getCalendarEventReferenceDate(event.end, start) > start
  );
};
